import partlyAutomatedIcon from '../assets/images/icons/outcome_partially_automated.svg'
import fullyAutomatedIcon from '../assets/images/icons/outcome_fully_automated.svg'
import wrongAnswerIcon from '../assets/images/icons/outcome_wrong_answer.svg'
import requestedOperatorIcon from '../assets/images/icons/outcome_requested_operator.svg'

class IntentsUsageTooltipUtils {
  // generates html for whole intent usages chart tooltip (hover on column)
  getTooltip(config, componentContext, outcomeTypes = ['fullyAutomated', 'partlyAutomated', 'wrongAnswer']) {
    const vm = componentContext
    const { w, dataPointIndex, series } = config
    let lines = ''
    const categoryTotal = this.getCategoryTotal(series, dataPointIndex)
    outcomeTypes.forEach((label, i) => {
      const categoryValue = series[outcomeTypes.length - (i + 1)][dataPointIndex]
      lines += this.getTooltipLine(label, categoryValue, categoryTotal, vm)
    })
    const totalUsages = vm.$parent.intents[dataPointIndex].usage

    return `
      ${this.getToolTipHeader(w.config.xaxis.categories[dataPointIndex], totalUsages)}
      <div class="pt-2 px-3 pb-1 rounded-b-xl">
        ${lines}
      </div>
    `
  }

  // generates html for tooltip's 1 line ([icon] label: [percentage][total]
  getTooltipLine(outcomeType, categoryValue, categoryTotal, vm) {
    const labelMap = {
      fullyAutomated: 'Fully automated:',
      partlyAutomated: 'Partly automated:',
      wrongAnswer: 'Wrong Answer:',
      requestedOperator: 'Requested operator:'
    }
    const categoryShare = (categoryValue / categoryTotal * 100).toFixed(2)

    return `
      <div class="flex py-1">
        <span class="pr-2">${this.getLegendIcon(outcomeType)}</span>
        <span class="mr-2 text-sm">${labelMap[outcomeType]}</span>
        <div class="w-full text-right text-sm">
          <span class="font-semibold mr-0.5 text-black-soft">${categoryShare}%</span>
          <span class="font-normal">
            (${(categoryValue / 100 * vm.total).toFixed(0)})
          </span>
        </div>
      </div>
    `
  }

  // get html for legend icons in column tooltip
  getLegendIcon(outcomeType) {
    const iconsMap = {
      fullyAutomated: fullyAutomatedIcon,
      partlyAutomated: partlyAutomatedIcon,
      wrongAnswer: wrongAnswerIcon,
      requestedOperator: requestedOperatorIcon
    }

    return `
      <img src="${iconsMap[outcomeType]}" alt="${outcomeType}" class="h-4 w-4"></img>
    `
  }

  // get HTML for upper part(header) of tooltip
  getToolTipHeader(headerLabel, totalUsages) {
    return `
      <div class="rounded-t-lg bg-soft p-3 font-semibold text-sm text-black-soft flex">
        <div class="w-48 truncate">${headerLabel}</div><span class="font-normal ml-1">${totalUsages}</span>
      </div>
    `
  }

  getCategoryTotal(series, columnIndex) {
    return series.map(seriesValues => seriesValues[columnIndex])
      .reduce((sum, seriesValue) => sum + seriesValue, 0)
  }
}

export default new IntentsUsageTooltipUtils()
